"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrettyLoaderReact = void 0;
const react_1 = require("react");
const PrettyLoader_1 = require("./PrettyLoader");
const useMergedRefs_1 = __importDefault(require("@restart/hooks/useMergedRefs"));
const hooks_1 = require("@restart/hooks");
const PrettyLoaderReact = (0, react_1.forwardRef)(({ children, isLoading, onClick, disabled, config, }, forwarderRef) => {
    const refNode = (0, react_1.useRef)();
    const [prettyLoader, setPrettyLoader] = (0, react_1.useState)();
    const refs = (0, useMergedRefs_1.default)(refNode, forwarderRef);
    const isLoadingPrevious = (0, hooks_1.usePrevious)(isLoading);
    (0, react_1.useEffect)(() => {
        setPrettyLoader(PrettyLoader_1.PrettyLoader.init(refNode.current, config));
    }, [refNode.current]);
    (0, react_1.useEffect)(() => {
        if (!prettyLoader) {
            return;
        }
        if (isLoading) {
            prettyLoader.show();
        }
        else if (isLoadingPrevious) {
            prettyLoader.hide();
        }
    }, [isLoading, isLoadingPrevious, prettyLoader]);
    const childrenProps = {
        ref: refs,
    };
    if (onClick) {
        childrenProps.onClick = onClick;
    }
    if (disabled) {
        childrenProps.disabled = disabled;
    }
    return (0, react_1.cloneElement)(children, childrenProps);
});
exports.PrettyLoaderReact = PrettyLoaderReact;
